import type { TFunction } from 'i18next';

/**
 * 操作类型对应的 Chip 颜色类型
 * 与 MUI Chip 组件的 color 属性兼容
 */
export type ActionColor = 'success' | 'info' | 'warning' | 'error' | 'default' | 'primary' | 'secondary';

/**
 * 获取操作类型的本地化标签
 */
export function getActionLabel(action: string, t: TFunction): string {
  const key = `logs.actions.${action}`;
  const translated = t(key);
  return translated !== key ? translated : action;
}

/**
 * 获取操作类型对应的颜色
 * 始终返回有效的 Chip 颜色值，不返回 undefined
 */
export function getActionColor(action: string): ActionColor {
  const colorMap: Record<string, ActionColor> = {
    activation: 'success',
    heartbeat: 'info',
    validation: 'warning',
    deactivation: 'error',
    file_process: 'default',
  };
  // 确保返回一个有效的非 undefined 值
  return colorMap[action] ?? 'default';
}

/**
 * 获取操作类型对应的图表颜色（十六进制）
 */
export function getActionChartColor(action: string): string {
  const ACTION_COLORS: Record<string, string> = {
    activation: '#4caf50',
    heartbeat: '#2196f3',
    validation: '#ff9800',
    deactivation: '#f44336',
    file_process: '#9c27b0',
  };
  return ACTION_COLORS[action] || '#757575';
}
